import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './motoristaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import Aguardando from '../common/template/aguardando';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaGrupo,
	atualizarDataLake
} from './motoristaActions';

class Motorista extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ativos: true,
		inativos: false,
		ordenacao: {
			nome: 1
		}
	}

	componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista();
		this.props.getListaGrupo();
	}

	render() {
		return (
			<div>

				<Aguardando aguardando={this.props.aguardando} />

				<Content>

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}

					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}

					{this.props.modoTela == 'lista' ? this.lista() : null}

				</Content>
			</div>
		)
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i className='fas fa-sort-amount-down-alt' />;
		} else if (tipo == 2) {
			return <i className='fas fa-sort-amount-up' />;
		} else {
			return null;
		}
	}

	lista() {

		let lista = [];

		(this.props.lista || []).filter(item => {

			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(pesquisar => (pesquisar || '').trim())
					.filter(pesquisar => {

						if (
							pesquisar
							&& !(
								`
									${item.nome || ''}
									${item.nome_grupo || ''}
									${item.rg_cnh || ''}
									${item.rg || ''}
								`
							)
								.toUpperCase()
								.includes(pesquisar)
						) {
							return false;
						}

						return true;

					}).length > 0;

		}).forEach((item, i) => {

			let contratos = (item.contratos || []).filter(contrato => {

				if (!(this.state.ativos && this.state.inativos)) {

					if (this.state.ativos && contrato.data_desligamento) {
						return false;
					}

					if (this.state.inativos && !contrato.data_desligamento) {
						return false;
					}

					if (!this.state.ativos && !this.state.inativos) {
						return false;
					}
				}

				return true;
			});

			contratos.forEach((contrato, j) => {

				lista.push({
					...item,
					id_aux: `${item.id}_${i}_${j}_${contrato.data_admissao || ''}_${contrato.data_desligamento || ''}`,
					data_admissao: contrato.data_admissao,
					data_desligamento: contrato.data_desligamento,
					tempo_contrato: contrato.tempo_contrato
				});
			});
		});

		if (this.state.ordenacao.nome) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome == 1
					? ((a.nome || '') > (b.nome || '') ? 1 : -1)
					: ((a.nome || '') > (b.nome || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.nome_grupo) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome_grupo == 1
					? ((a.nome_grupo || '') > (b.nome_grupo || '') ? 1 : -1)
					: ((a.nome_grupo || '') > (b.nome_grupo || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.data_admissao) {

			lista.sort((a, b) =>
				this.state.ordenacao.data_admissao == 1
					? ((a.data_admissao || '') > (b.data_admissao || '') ? 1 : -1)
					: ((a.data_admissao || '') > (b.data_admissao || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.data_desligamento) {

			lista.sort((a, b) =>
				this.state.ordenacao.data_desligamento == 1
					? ((a.data_desligamento || '') > (b.data_desligamento || '') ? 1 : -1)
					: ((a.data_desligamento || '') > (b.data_desligamento || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.tempo_contrato) {

			lista.sort((a, b) => {

				const dataFimA = a.data_desligamento
					? new Date(a.data_desligamento)
					: new Date();

				const dataFimB = b.data_desligamento
					? new Date(b.data_desligamento)
					: new Date();

				const dataInicioA = a.data_admissao
					? new Date(a.data_admissao)
					: new Date(0);

				const dataInicioB = b.data_admissao
					? new Date(b.data_admissao)
					: new Date(0);

				const tempoA = dataFimA.getTime() - dataInicioA.getTime();
				const tempoB = dataFimB.getTime() - dataInicioB.getTime();

				return this.state.ordenacao.tempo_contrato == 1
					? tempoA - tempoB
					: tempoB - tempoA;
			});

		} else if (this.state.ordenacao.status) {

			lista.sort((a, b) => {

				const statusA = a.data_desligamento ? 'Inativo' : 'Ativo';
				const statusB = b.data_desligamento ? 'Inativo' : 'Ativo';

				return this.state.ordenacao.status == 1
					? (statusA > statusB ? 1 : -1)
					: (statusA > statusB ? -1 : 1);
			});

		} else if (this.state.ordenacao.cnh_validade) {

			lista.sort((a, b) =>
				this.state.ordenacao.cnh_validade == 1
					? ((a.cnh_validade || '') > (b.cnh_validade || '') ? 1 : -1)
					: ((a.cnh_validade || '') > (b.cnh_validade || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.rg) {

			lista.sort((a, b) =>
				this.state.ordenacao.rg == 1
					? ((a.rg || '') > (b.rg || '') ? 1 : -1)
					: ((a.rg || '') > (b.rg || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.rg_cnh) {

			lista.sort((a, b) =>
				this.state.ordenacao.rg_cnh == 1
					? ((a.rg_cnh || '') > (b.rg_cnh || '') ? 1 : -1)
					: ((a.rg_cnh || '') > (b.rg_cnh || '') ? -1 : 1)
			);
		}

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ContentCard>

				<ContentCardBody>

					<Row>

						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value =>
								this.setState({
									...this.state,
									pesquisar: value
								})
							}
						/>

						<Grid
							cols='12 1 1 1'
							style={{
								minWidth: 80,
								maxWidth: 80,
								paddingLeft: 0,
								paddingRight: 0,
								marginLeft: 4,
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center'
							}}
						>

							<div
								class={`filter-chip ${this.state.ativos ? 'active' : ''}`}
								style={{
									width: 80,
									fontSize: 12,
									marginBottom: 4,
									justifyContent: 'center'
								}}
								onClick={() => {
									this.setState({
										...this.state,
										ativos: !this.state.ativos
									});
								}}
							>
								<i
									class='fas fa-check-circle'
									style={{
										fontSize: 10,
										marginRight: 4,
										justifyContent: 'center'
									}}
								></i>
								Ativos
							</div>

							<div
								class={`filter-chip ${this.state.inativos ? 'active' : ''}`}
								style={{
									width: 80,
									fontSize: 12,
									marginTop: 0
								}}
								onClick={() => {
									this.setState({
										...this.state,
										inativos: !this.state.inativos
									});
								}}
							>
								<i
									class='fas fa-times-circle'
									style={{
										fontSize: 10,
										marginRight: 4
									}}
								></i>
								Inativos
							</div>

						</Grid>

						<div
							style={{
								width: 310,
								marginTop: 8,
								marginLeft: 8
							}}
						>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {
									this.props.getLista();
								}}
							>
								<i className='fas fa-sync-alt'></i>
								{' '}Atualizar
							</a>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {
									this.props.atualizarDataLake();
								}}
							>
								<i className='fas fa-database'></i>
								{' '}DataLake
							</a>

							<ExcelFile
								filename={'Motoristas'}
								element={
									<a
										className='btn btn-app bg-success'
										style={{
											marginLeft: 2,
											minWidth: 75
										}}
									>
										<i className='fas fa-file-excel'></i>
										{' '}Exportar
									</a>
								}
							>
								<ExcelSheet
									data={lista.map(item => ({
										...item,
										data_admissao_exportar: DateFormat.formatarDataSqlParaTela(
											item.data_admissao
										),
										data_desligamento_exportar: DateFormat.formatarDataSqlParaTela(
											item.data_desligamento
										),
										status_exportar: item.data_desligamento
											? 'Inativo'
											: 'Ativo',
										cnh_validade_exportar: DateFormat.formatarDataSqlParaTela(
											item.cnh_validade
										)
									}))}
									name='Motoristas'
								>

									<ExcelColumn
										label='Nome'
										value='nome'
									/>

									<ExcelColumn
										label='Grupo'
										value='nome_grupo'
									/>

									<ExcelColumn
										label='Admissão'
										value='data_admissao_exportar'
									/>

									<ExcelColumn
										label='Desligamento'
										value='data_desligamento_exportar'
									/>

									<ExcelColumn
										label='Tempo Contrato'
										value='tempo_contrato'
									/>

									<ExcelColumn
										label='Status'
										value='status_exportar'
									/>

									<ExcelColumn
										label='Validade CNH'
										value='cnh_validade_exportar'
									/>

									<ExcelColumn
										label='RG'
										value='rg'
									/>

									<ExcelColumn
										label='RG CNH'
										value='rg_cnh'
									/>

								</ExcelSheet>

							</ExcelFile>

						</div>

					</Row>

					<div
						style={{
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768
								? '100%'
								: (
									window.innerWidth < 1093
										? `${window.innerHeight - 300}px`
										: (
											window.innerWidth < 1799
												? `${window.innerHeight - 180}px`
												: (
													window.innerWidth < 4000
														? `${window.innerHeight - 180}px`
														: `${window.innerHeight - 110}px`
												)
										)
								)
						}}
					>

						<Table
							responsive
							border
							striped
							alturaFixa
							maxHeight={
								window.innerWidth < 768
									? '100%'
									: (
										window.innerWidth < 1093
											? `${window.innerHeight - 300}px`
											: (
												window.innerWidth < 1799
													? `${window.innerHeight - 180}px`
													: (
														window.innerWidth < 4000
															? `${window.innerHeight - 180}px`
															: `${window.innerHeight - 110}px`
													)
											)
									)
							}
						>

							<THead>

								<Tr
									backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}
								>

									<Th
										minWidth={200}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													nome: this.getNovaOrdenacao(
														this.state.ordenacao.nome
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignLeft
									>
										Nome {this.getIconeOrdenacao(
											this.state.ordenacao.nome
										)}
									</Th>

									<Th
										minWidth={170}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													nome_grupo: this.getNovaOrdenacao(
														this.state.ordenacao.nome_grupo
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Grupo {this.getIconeOrdenacao(
											this.state.ordenacao.nome_grupo
										)}
									</Th>

									<Th
										minWidth={110}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													data_admissao: this.getNovaOrdenacao(
														this.state.ordenacao.data_admissao
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Admissão {this.getIconeOrdenacao(
											this.state.ordenacao.data_admissao
										)}
									</Th>

									<Th
										minWidth={120}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													data_desligamento: this.getNovaOrdenacao(
														this.state.ordenacao.data_desligamento
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Desligamento {this.getIconeOrdenacao(
											this.state.ordenacao.data_desligamento
										)}
									</Th>

									<Th
										minWidth={130}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													tempo_contrato: this.getNovaOrdenacao(
														this.state.ordenacao.tempo_contrato
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Tempo Contrato {this.getIconeOrdenacao(
											this.state.ordenacao.tempo_contrato
										)}
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													status: this.getNovaOrdenacao(
														this.state.ordenacao.status
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Status {this.getIconeOrdenacao(
											this.state.ordenacao.status
										)}
									</Th>

									<Th
										minWidth={120}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													cnh_validade: this.getNovaOrdenacao(
														this.state.ordenacao.cnh_validade
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Validade CNH {this.getIconeOrdenacao(
											this.state.ordenacao.cnh_validade
										)}
									</Th>

									<Th
										minWidth={110}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													rg: this.getNovaOrdenacao(
														this.state.ordenacao.rg
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										RG {this.getIconeOrdenacao(
											this.state.ordenacao.rg
										)}
									</Th>

									<Th
										minWidth={110}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													rg_cnh: this.getNovaOrdenacao(
														this.state.ordenacao.rg_cnh
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										RG CNH {this.getIconeOrdenacao(
											this.state.ordenacao.rg_cnh
										)}
									</Th>

									<Th
										minWidth={70}
										width={70}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
									</Th>

								</Tr>

							</THead>

							<TBody>

								{lista.map((item, i) => (

									<Tr
										key={`${item.id}-${item.id_aux}`}
										backgroundColor={
											this.state.linhaSelecionada == item.id_aux
												? '#bcc7eb'
												: (
													i % 2 == 0
														? '#ffffff'
														: '#f5f5f5'
												)
										}
										onClick={() =>
											this.setState({
												...this.state,
												linhaSelecionada: item.id_aux
											})
										}
									>

										<Td
											color={'#000'}
											alignLeft
											small
										>
											{item.nome}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.nome_grupo}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{DateFormat.formatarDataSqlParaTela(
												item.data_admissao
											)}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{DateFormat.formatarDataSqlParaTela(
												item.data_desligamento
											)}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.tempo_contrato}
										</Td>

										<Td
											alignCenter
											minWidth={90}
										>

											<span
												title={
													item.data_desligamento
														? 'Inativo'
														: 'Ativo'
												}
												style={{
													display: 'inline-flex',
													alignItems: 'center',
													justifyContent: 'center',
													minWidth: 65,
													height: 24,
													paddingLeft: 8,
													paddingRight: 8,
													borderRadius: 12,
													backgroundColor: item.data_desligamento
														? '#dc3545'
														: '#28a745',
													color: '#ffffff',
													fontSize: 11,
													fontWeight: 'bold'
												}}
											>

												<i
													className={
														item.data_desligamento
															? 'fas fa-times'
															: 'fas fa-check'
													}
													style={{
														marginRight: 5
													}}
												/>

												{item.data_desligamento
													? 'Inativo'
													: 'Ativo'}

											</span>

										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{DateFormat.formatarDataSqlParaTela(
												item.cnh_validade
											)}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.rg}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.rg_cnh}
										</Td>

										<Td
											minWidth={70}
											width={70}
											alignCenter
										>

											{!item.data_desligamento ? (

												<ButtonTable
													type={'warning'}
													icon={'fas fa-pencil-alt'}
													visible={true}
													small
													event={() => {

														const registro = {
															...item,
															data_admissao: DateFormat.formatarDataSqlParaTela(
																item.data_admissao
															),
															data_desligamento: DateFormat.formatarDataSqlParaTela(
																item.data_desligamento
															),
															cnh_validade: DateFormat.formatarDataSqlParaTela(
																item.cnh_validade
															)
														};

														this.props.setModoTela(
															'cadastro',
															registro
														);

														this.props.initForm(
															registro
														);
													}}
												/>

											) : null}

										</Td>

									</Tr>

								))}

							</TBody>

						</Table>

					</div>

				</ContentCardBody>

			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.motorista.modoTela,
	aguardando: state.motorista.aguardando,
	lista: state.motorista.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaGrupo,
	atualizarDataLake
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Motorista);